import type { NavigateFunction } from 'react-router-dom'
import {
  LoginLocationState,
  SESSION_EXPIRED_MESSAGE,
} from '../api/auth'

export function loginStateForExpiredSession(): LoginLocationState {
  return { message: SESSION_EXPIRED_MESSAGE }
}

export function isSessionExpiredMessage(message: string): boolean {
  return message === SESSION_EXPIRED_MESSAGE
}

export function redirectToLoginForExpiredSession(
  navigate: NavigateFunction,
  options?: { onClose?: () => void },
): void {
  options?.onClose?.()
  navigate('/login', { state: loginStateForExpiredSession() })
}

export function redirectIfSessionExpired(
  navigate: NavigateFunction,
  err: unknown,
  options?: { onClose?: () => void },
): boolean {
  const message = err instanceof Error ? err.message : ''
  if (!isSessionExpiredMessage(message)) return false
  redirectToLoginForExpiredSession(navigate, options)
  return true
}
